export default "__VITE_ASSET__DBHnA2N2__"